/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {PixiesVsPiratesGameModuleConfig} from "./PixiesVsPiratesGameModuleConfig";

require("../../node_modules/gsap/src/uncompressed/plugins/PixiPlugin");

export class PixiesVsPirates extends SlotGame {

    constructor() {
        super(PixiesVsPiratesGameModuleConfig.instance);
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L5",
                    "M5",
                    "M3",
                    "L2",
                    "M1",
                    "M4",
                    "L2",
                    "L4"
                ],
                [
                    "L2",
                    "L1",
                    "L2",
                    "L3",
                    "L4",
                    "M2",
                    "M4",
                    "L2"
                ],
                [
                    "M5",
                    "M2",
                    "L2",
                    "M5",
                    "M5",
                    "L5",
                    "L6",
                    "L5"
                ],
                [
                    "E",
                    "L3",
                    "M4",
                    "L3",
                    "L2",
                    "L6",
                    "L5",
                    "M3"
                ],
                [
                    "M6",
                    "L6",
                    "M3",
                    "L4",
                    "L5",
                    "M5",
                    "L6",
                    "L1"
                ],
                [
                    "L1",
                    "L3",
                    "L5",
                    "L1",
                    "M6",
                    "L2",
                    "L3",
                    "M4"
                ]
            ],
            "evaluatedArea": [
                [
                    "X",
                    "X",
                    "X",
                    "M1",
                    "M4",
                    "L2"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "L4",
                    "M2",
                    "M4"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "M5",
                    "L5",
                    "L6"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "L2",
                    "L6",
                    "L5"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "L5",
                    "M5",
                    "L6"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "M6",
                    "L2",
                    "L3"
                ]
            ],
            "gameAreaSize": [
                3,
                3,
                3,
                3,
                3,
                3
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "totalSpinWinningsNonMultiplied": 0,
            "accumulatedRoundWin": 0,
            "reelsNextSpin": "BASE_REELSET",
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "doReelNudge": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "wildOnReel": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "extraSymbolsOnTop": [
                [
                    "M4",
                    "L5",
                    "M3",
                    "L2",
                    "L1"
                ],
                [
                    "L4",
                    "L3",
                    "L1",
                    "L4",
                    "L4"
                ],
                [
                    "L5",
                    "L1",
                    "M5",
                    "L4",
                    "M4"
                ],
                [
                    "M1",
                    "W",
                    "W",
                    "W",
                    "M4"
                ],
                [
                    "L3",
                    "L3",
                    "S",
                    "L1",
                    "M1"
                ],
                [
                    "M6",
                    "M2",
                    "L2",
                    "L4",
                    "M5"
                ]
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "freespinTriggeredThisSpin": false,
            "reelsEnteringFreespin": [
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ],
                [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null
                ]
            ],
            "gameAreaSizeEnteringFreespin": [
                3,
                3,
                3,
                3,
                3,
                3
            ],
            "wildMultipliersEnteringFreespin": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "payoutMultiplier": 1,
            "playerFSSelection": -1,
            "freespinRound": 0,
            "pixieFSCount": 0,
            "pirateFSCount": 0,
            "wildMultipliers": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "numberOfWaysWon": 0,
            "mysterySymbolOnReel": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "mysterySymbolSize": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "mysterySymbolRevealed": "",
            "mysterySymbolPositions": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "xWaysSymbolMayGiveWin": false,
            "pixieCollectPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "pirateCollectPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "numberOfSpinsPerFSRound": 0,
            "selectionBy": ""
        };
    }
}